import { pascalize, decamelize } from 'humps'
import { getProductDetailByPropertyName, PRODUCT_NAME_VARIATION_TYPES } from './cfs-card'

export function safeStringify(obj: unknown): string | undefined {
  try {
    return JSON.stringify(obj)
  } catch (err) {
    return ''
  }
}

export function getUserCountryCode(req: { locality?: { country?: string } }): string {
  return (req.locality?.country || '').toLowerCase()
}

export function formatUniversalLinkProductName(productName: string): string {
  const systemProductName = getProductDetailByPropertyName(
    productName,
    PRODUCT_NAME_VARIATION_TYPES.ALIAS,
  )?.system

  if (!systemProductName) return productName

  return pascalize(systemProductName.toLowerCase())
}

export function formatUniversalLinkProductNameToSystem(productName: string): string {
  const uLinkProductName = formatUniversalLinkProductName(productName)
  return decamelize(uLinkProductName).toUpperCase()
}
